import { connectionStore, ConfigStore } from "../../Stores";
import { STR_ERRORS } from "../../Strings";
import { unsubscribe } from "../Unsubscribe";
import { subscribe } from "../Subscribe";
import { getQueryIDs } from "../GetQueryIDs";
let timeout = undefined;
export function applyQueries(store, connectionName, r) {
    const conn = connectionStore.get(connectionName);
    if (typeof conn === "undefined") {
        throw new Error(STR_ERRORS.NoConnectionsAvailable);
    }
    if (typeof r.query === "undefined") {
        const clearConnectionResult = unsubscribe(store, conn, r);
        if (store.getAllConnections().length === 0) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                // code available only in debug builds is excluded from coverage
                /* istanbul ignore next */
                if (process.env.NODE_ENV === "development") {
                    console.warn(`Called connection.deactivate() due to inactivity for ${ConfigStore.config.inactiveTTL_MS} ms.`);
                }
                conn.deactivate().catch(console.error);
            }, ConfigStore.config.inactiveTTL_MS);
        }
        return clearConnectionResult;
    }
    clearTimeout(timeout);
    // Get query details from the store before we set the new query
    const ids = getQueryIDs(store, r);
    store.set(r.query, r);
    return conn.isConnected()
        .then(x => x ? x : conn.connect())
        .then(x => {
        subscribe(store, conn, r, ids);
        return x;
    })
        // TODO: handle "Can't open WebSocket while closing." error
        // this error could happen during the normal operation of the connection
        // while token renew, back-end time to live or some other event trigger
        // disconnection and we are trying to send new messages.
        // This is handled by the rest of the flows as it is going to trigger reconnect
        // and eventually succeed with after some forced incremental delay.
        // Since the error that is thrown is not in our package, there is no way we can hide the stack trace
        .catch(console.warn);
}
//# sourceMappingURL=ApplyQueries.js.map